import { flowConditionalConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const ConditionalBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Conditional),
  config: flowConditionalConfigSchema,
});
export type ConditionalBlock = z.infer<typeof ConditionalBlockSchema>;
